import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ContenedoresService } from './../../../../../../../services/API/contenedores/contenedores.service';
import { XlsxService } from './../../../../../shared/xlsx/xlsx.service';
import { ConfirmDialogComponent } from './../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { NewTipoComponent } from './components/new-tipo/new-tipo.component';
import { EditTipoComponent } from './components/edit-tipo/edit-tipo.component';
import { NotificationServiceService } from './../../../../../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../../../../../services/API/auth/auth.service';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
    selector: 'app-contenedores-tipos',
    templateUrl: './contenedores-tipos.component.html',
    styleUrls: ['./contenedores-tipos.component.css'],
    standalone: false
})
export class ContenedoresTiposComponent implements OnInit {

  showProgressBar: boolean = true;
  displayedColumns = ['id', 'nombre'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog, public authService: AuthService, private xlsxService: XlsxService, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_total');
    this.getTiposContenedores();
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  getTiposContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getTiposContenedores().subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newTipoContenedor(){
    const newNivelDialog = this.dialog.open(NewTipoComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.contenedoresService.newTipoContenedor(result["nombre"]).subscribe(() => {
          this.notificationService.openSnackBar("Tipo creado correctamente!");
          this.showProgressBar = false;
          this.getTiposContenedores();
        });
      }
    });
  }

  editarTipoContenedor(id: number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["id"] === id){
        const modifDialog = this.dialog.open(EditTipoComponent, {
          data: {'nombre': this.dataSource1[i]["nombre"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result){
            this.showProgressBar = true;
            this.contenedoresService.updateTipoContenedor(id, result["nombre"]).subscribe(() => {
              this.notificationService.openSnackBar("Tipo modificado correctamente!");
              this.showProgressBar = false;
              this.getTiposContenedores();
            });
          }
        });
        break;
      }
    }
  }

  deleteTipoContenedor(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar tipo', body: '¿Seguro que deseas eliminar este tipo?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.contenedoresService.deleteTipoContenedor(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Tipo eliminado correctamente!");
          this.showProgressBar = false;
          this.getTiposContenedores();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Tipos por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    this.xlsxService.saveExcel(this.table.nativeElement, 'Contenedores - Tipos');
  }

}
